import { render, staticRenderFns } from "./VideoCallPage.vue?vue&type=template&id=3feeeaac&"
import script from "./VideoCallPage.vue?vue&type=script&lang=js&"
export * from "./VideoCallPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallPage.vue?vue&type=style&index=0&id=3feeeaac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports